// Definition of special payments in percent
export const transformationsGeldProzent = 18.4;
export const tZugAProzent = 27.5;
export const tZugBProzent = 18.5;
export const urlaubsgeldProzent = 69;